import { render, staticRenderFns } from "./MyProcedures.vue?vue&type=template&id=d82bc552&scoped=true&lang=pug"
import script from "./MyProcedures.vue?vue&type=script&lang=js"
export * from "./MyProcedures.vue?vue&type=script&lang=js"
import style0 from "./MyProcedures.vue?vue&type=style&index=0&id=d82bc552&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d82bc552",
  null
  
)

export default component.exports